"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _memoizeFormElement = _interopRequireDefault(require("../../Utilities/memoizeFormElement"));

var _Form = require("../../Form");

var _Components = require("../../Components");

var _Utilities = require("../../Utilities");

var _Popover = require("../../../Popover");

var _RenderDropdownOptions = _interopRequireDefault(require("./RenderDropdownOptions"));

var _Elements = require("../../Components/Elements");

var _Validations = require("../../Validations");

var _boldifySubstringMatch = _interopRequireDefault(require("./boldifySubstringMatch"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Dropdown = function Dropdown(_ref) {
  var name = _ref.name,
      children = _ref.children,
      value = _ref.value,
      placeholder = _ref.placeholder,
      onChange = _ref.onChange,
      multiselect = _ref.multiselect,
      label = _ref.label,
      id = _ref.id,
      isRequired = _ref.isRequired,
      validations = _ref.validations,
      submitAttempted = _ref.submitAttempted,
      attr = _ref.attr,
      allowUserInput = _ref.allowUserInput,
      filter = _ref.filter,
      shouldBoldifySubstringMatch = _ref.shouldBoldifySubstringMatch,
      noFilterOnOpen = _ref.noFilterOnOpen,
      optionHeightForScrollTo = _ref.optionHeightForScrollTo,
      withOptionPreview = _ref.withOptionPreview,
      hideError = _ref.hideError;

  // State for whether the dropdown is open or not
  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      show = _useState2[0],
      setShow = _useState2[1]; // Accessibility requirement


  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      active = _useState4[0],
      setActive = _useState4[1];

  var _useState5 = (0, _react.useState)(value || ['']),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      inputValue = _useState6[0],
      setInputValue = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
      shouldShowFilteredOptions = _useState8[0],
      setShouldShowFilteredOptions = _useState8[1];

  var inputFocusRef = (0, _react.useRef)(null); // Not in state to avoid unnecessary renders

  var filtered = false;
  (0, _react.useEffect)(function () {
    // on dropdown close
    // this sets the dropdown form value (onChange) and displayed value (setInputValue) to ''
    // if the displayed value doesn't match the form value
    // the form value will only ever be one of the dropdown array values
    if (allowUserInput && !show && (inputValue === null || inputValue === void 0 ? void 0 : inputValue[0]) !== (value === null || value === void 0 ? void 0 : value[0])) {
      onChange({
        name: name,
        value: ['']
      });
      setInputValue(['']);
    }
  }, [show, inputValue]);

  var onClick = function onClick(_ref2) {
    var checked = _ref2.checked,
        optionValue = _ref2.optionValue,
        index = _ref2.index;
    var newValue = (0, _toConsumableArray2["default"])(value);
    if (checked) newValue.splice(newValue.indexOf(optionValue), 1);else {
      // eslint-disable-next-line no-lonely-if
      if (multiselect && !allowUserInput) newValue.push(optionValue);else newValue[0] = optionValue;
    }
    setActive(index);
    if (allowUserInput) setInputValue(newValue.length > 0 ? [newValue[0]] : ['']);
    onChange({
      name: name,
      value: newValue
    });
  };

  var toggle = function toggle() {
    if (!allowUserInput && !show) setActive(0);
    if (show) setActive(null);
    setShow(!show);
    if (allowUserInput && noFilterOnOpen && shouldShowFilteredOptions) setShouldShowFilteredOptions(false);
  };

  var buildOptions = function buildOptions() {
    if (children == null) return null;
    var flatChildren = children.flat();
    var matchIndex;
    var frontHalfOptions = [];
    var backHalfOptions = [];
    var isOdd = flatChildren.length % 2 === 1;
    var pointer1 = Math.ceil(flatChildren.length / 2);

    var _loop = function _loop(i) {
      var pointer2 = pointer1 + i;
      var startChild = flatChildren[i];
      var endChild = isOdd && pointer2 === flatChildren.length ? null : flatChildren[pointer2];
      var childArray = [startChild, endChild];
      if (!endChild) childArray = [startChild]; // eslint-disable-next-line no-loop-func

      var builtChildren = childArray.map(function (child, j) {
        if (!child || !child.props) return null;
        var index;

        if (j === 1) {
          index = pointer2;
        } else {
          index = i;
        }

        if (noFilterOnOpen && shouldShowFilteredOptions || !noFilterOnOpen) {
          if (filter === 'basic') {
            if (inputValue !== null && inputValue !== void 0 && inputValue[0]) filtered = true;

            if (!child.props.value.toLowerCase().includes(inputValue[0].toLowerCase())) {
              return null;
            }
          }

          if (typeof filter === 'function') {
            if (!filter(inputValue[0].toLowerCase(), child.props.value.toLowerCase())) return null;
          }
        }

        var isExactMatch = filter && !!inputValue[0] && child.props.value.toLowerCase() === inputValue[0].toLowerCase();

        if (isExactMatch) {
          matchIndex = index;
        }

        var props = {};
        props.checked = value.includes(child.props.value);
        props.onClick = onClick;
        props.toggle = toggle;
        props.id = "".concat(name, "-option-").concat(index);
        props.active = active === index;
        props.index = index;

        if (filter && shouldBoldifySubstringMatch) {
          if (!!inputValue[0] && filtered || value.includes(child.props.value)) {
            props.modifySubstring = function (string) {
              return (0, _boldifySubstringMatch["default"])(string, inputValue[0]);
            };
          }
        }

        return /*#__PURE__*/_react["default"].cloneElement(child, props);
      });

      if (builtChildren[1]) {
        frontHalfOptions.push(builtChildren[0]);
        backHalfOptions.push(builtChildren[1]);
      } else {
        frontHalfOptions.push(builtChildren[0]);
      }
    };

    for (var i = 0; i < pointer1; i += 1) {
      _loop(i);
    }

    var builtOptions = [].concat(frontHalfOptions, backHalfOptions);

    if (filtered && builtOptions.length !== 0) {
      builtOptions = builtOptions.filter(function (option) {
        return option !== null;
      });
      builtOptions = builtOptions.map(function (option, builtIndex) {
        var props = {};
        props.id = "".concat(name, "-option-").concat(builtIndex);
        props.active = active === builtIndex;
        props.index = builtIndex;
        return /*#__PURE__*/_react["default"].cloneElement(option, props);
      });
    }

    return {
      builtOptions: builtOptions,
      matchIndex: matchIndex
    };
  };

  (0, _react.useEffect)(function () {
    // focuses the input on open of dropdown
    // the input doesn't necessarily get focused without this
    if (allowUserInput && inputFocusRef && inputFocusRef.current) inputFocusRef.current.focus();
  }, [show, inputFocusRef]);
  (0, _react.useEffect)(function () {
    // when input value changes, start dropdown filtering
    // allows dropdown to not be filtered on open, but rather on input value change
    if (noFilterOnOpen && !shouldShowFilteredOptions && show) setShouldShowFilteredOptions(true);
  }, [inputValue]);

  var _buildOptions = buildOptions(),
      builtOptions = _buildOptions.builtOptions,
      matchIndex = _buildOptions.matchIndex;

  var getOptionInfo = function getOptionInfo(which) {
    return _react["default"].Children.toArray(builtOptions).reduce(function (result, child) {
      if (!child || !child.props) return result;

      if (value.includes(child.props.value)) {
        result.push(child.props[which]);
      }

      return result;
    }, []);
  };

  var labelClassName = value.length === 0 ? 'placeholder' : '';
  var dropdownSelection = !labelClassName ? getOptionInfo('label').join(', ') : placeholder;

  var attributes = _objectSpread(_objectSpread({}, attr), {}, {
    tabIndex: allowUserInput ? -1 : 0,
    'aria-haspopup': 'listbox',
    'aria-labelledby': "".concat(id, "-label ").concat(id),
    'aria-placeholder': labelClassName && !allowUserInput ? placeholder : undefined,
    'aria-expanded': show ? 'true' : 'false'
  });

  var triggerRef = (0, _react.useRef)(null); // Allows using arrow keys and enter once dropdown is open

  var handleKey = function handleKey(event) {
    if (show && active !== null) {
      if (event.key === 'ArrowDown' && active !== _react["default"].Children.count(builtOptions) - 1) setActive(active + 1);else if (event.key === 'ArrowUp' && active !== 0) setActive(active - 1);else if (event.key === 'PageUp') setActive(0);else if (event.key === 'PageDown') setActive(_react["default"].Children.count(builtOptions) - 1);else if (event.key === 'Tab') toggle();else if (event.key === 'Enter') {
        event.preventDefault();
        onClick({
          checked: getOptionInfo('index').includes(active),
          index: active,
          optionValue: _react["default"].Children.toArray(builtOptions)[active].props.value
        });
        setActive(0);
      }
    }
  };

  var errorId = (0, _Utilities.getFormErrorId)(validations, submitAttempted);
  return /*#__PURE__*/_react["default"].createElement(_Elements.InputWrapper, {
    className: errorId ? 'form-error' : ''
  }, /*#__PURE__*/_react["default"].createElement(_Popover.Popover, {
    id: "".concat(name, "-dropdown-id"),
    render: /*#__PURE__*/_react["default"].createElement(_RenderDropdownOptions["default"], {
      builtOptions: builtOptions,
      name: name,
      matchIndex: matchIndex,
      scrollToSelection: noFilterOnOpen && !filtered,
      show: show,
      optionHeightForScrollTo: optionHeightForScrollTo
    }),
    fullWidth: true,
    popoverNestedRole: "listbox",
    show: show,
    onClickout: toggle,
    triggerRef: triggerRef,
    triggerShow: toggle,
    noFocusOnOpen: !!allowUserInput,
    noEnterToOpen: !!allowUserInput || show,
    attr: {
      'aria-labelledby': id,
      'aria-activedescendant': "option-".concat(active),
      tabIndex: '-1',
      id: "".concat(name, "-dropdown-scroll-id")
    }
  }, allowUserInput ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Components.Label, {
    label: label,
    name: name,
    id: "".concat(id, "-label"),
    htmlFor: "".concat(name, "-input"),
    isRequired: isRequired
  }), /*#__PURE__*/_react["default"].createElement(_Elements.StyledDropdown, (0, _extends2["default"])({
    onKeyDown: handleKey,
    noPadding: true,
    role: "button",
    onClick: toggle,
    id: id
  }, attributes, {
    ref: triggerRef
  }), /*#__PURE__*/_react["default"].createElement(_Elements.StyledInput, {
    onKeyDown: function onKeyDown(e) {
      if (e.key === 'Tab' && active === null) {
        if (show) {
          e.preventDefault();
          setActive(!filtered && matchIndex ? matchIndex : 0);
        }
      }

      if (e.key === 'ArrowDown' && active === null) {
        e.preventDefault();

        if (!show) {
          setActive(0);
          toggle();
        }
      }

      if (e.key === 'Enter' && active === null) {
        e.preventDefault();

        if (!show) {
          toggle();
        }
      }
    },
    fullWidth: true,
    noBorder: true,
    transparentBg: true,
    attr: {
      placeholder: placeholder || undefined,
      'aria-placeholder': placeholder || undefined,
      autoComplete: 'off',
      'data-lpignore': 'true'
    },
    name: "".concat(name, "-input"),
    id: "".concat(name, "-input"),
    onChange: function onChange(e) {
      if (!show) {
        toggle();
      }

      setInputValue([e.value]);
    },
    value: inputValue[0]
  }))) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Components.Label, {
    label: label,
    name: name,
    id: "".concat(id, "-label"),
    isRequired: isRequired,
    onClick: toggle
  }), /*#__PURE__*/_react["default"].createElement(_Elements.StyledDropdown, (0, _extends2["default"])({
    onKeyDown: handleKey,
    role: "button",
    onClick: toggle,
    id: id
  }, attributes, {
    ref: triggerRef
  }), /*#__PURE__*/_react["default"].createElement(_Components.Label, {
    className: labelClassName,
    label: dropdownSelection,
    OptionPreview: withOptionPreview(value === null || value === void 0 ? void 0 : value[0])
  })))), !hideError && /*#__PURE__*/_react["default"].createElement(_Components.ErrorMessage, {
    id: errorId
  }));
};

Dropdown.propTypes = {
  placeholder: _propTypes["default"].string,
  submitAttempted: _propTypes["default"].bool.isRequired,
  validations: _propTypes["default"].shape(),
  value: _propTypes["default"].arrayOf(_propTypes["default"].string),
  name: _propTypes["default"].string.isRequired,
  id: _propTypes["default"].string.isRequired,
  onChange: _propTypes["default"].func.isRequired,
  attr: _propTypes["default"].shape(),
  isRequired: _propTypes["default"].bool,
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func, _propTypes["default"].node]).isRequired,
  multiselect: _propTypes["default"].bool,
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]).isRequired,
  initialValue: _propTypes["default"].arrayOf(_propTypes["default"].string),
  allowUserInput: _propTypes["default"].oneOf([true, false, 'limited']),
  filter: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].oneOf(['basic'])]),
  shouldBoldifySubstringMatch: _propTypes["default"].bool,
  noFilterOnOpen: _propTypes["default"].bool,
  optionHeightForScrollTo: _propTypes["default"].number,
  withOptionPreview: _propTypes["default"].func,
  hideError: _propTypes["default"].bool
};
Dropdown.defaultProps = {
  validations: undefined,
  value: undefined,
  placeholder: undefined,
  initialValue: [],
  attr: {},
  isRequired: false,
  multiselect: false,
  allowUserInput: false,
  filter: null,
  shouldBoldifySubstringMatch: false,
  noFilterOnOpen: false,
  optionHeightForScrollTo: 36,
  withOptionPreview: function withOptionPreview() {
    return null;
  },
  // returns an element to display along-side the selected option/value (preview element)
  hideError: false
};
Dropdown.Validations = {
  required: _objectSpread(_objectSpread({}, _Validations.required), {}, {
    fn: function fn(value) {
      return value.length === 0;
    }
  }),
  maxLength: _Validations.maxLength
};
var MemoDropdown = (0, _memoizeFormElement["default"])(Dropdown);

var _default = (0, _Form.asFormElement)(MemoDropdown);

exports["default"] = _default;